module.exports = __webpack_public_path__ + "media/assets/images/blog/amazed-formal-male-looking-at-laptop-small-90fd25771cd773c79fb2ec2d68b0602f.jpg";